import { render, staticRenderFns } from "./charactersIntro.vue?vue&type=template&id=27e1f379&"
import script from "./charactersIntro.vue?vue&type=script&lang=js&"
export * from "./charactersIntro.vue?vue&type=script&lang=js&"
import style0 from "./charactersIntro.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports